/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ChargeList } from '../models/charge-list';
import { exportStationTransactionsVnf } from '../fn/vnf-sites-operation/export-station-transactions-vnf';
import { ExportStationTransactionsVnf$Params } from '../fn/vnf-sites-operation/export-station-transactions-vnf';
import { getStationChargeOnGoingVnf } from '../fn/vnf-sites-operation/get-station-charge-on-going-vnf';
import { GetStationChargeOnGoingVnf$Params } from '../fn/vnf-sites-operation/get-station-charge-on-going-vnf';
import { getStationTransactions } from '../fn/vnf-sites-operation/get-station-transactions';
import { GetStationTransactions$Params } from '../fn/vnf-sites-operation/get-station-transactions';
import { TransactionPagedList } from '../models/transaction-paged-list';


/**
 * All about the VNF sites operation
 */
@Injectable({ providedIn: 'root' })
export class VnfSitesOperationService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStationTransactions()` */
  static readonly GetStationTransactionsPath = '/custom/stations/{uid}/transactions/search';

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationTransactions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationTransactions$Response(params: GetStationTransactions$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionPagedList>> {
    return getStationTransactions(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of transactions, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationTransactions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationTransactions(params: GetStationTransactions$Params, context?: HttpContext): Observable<TransactionPagedList> {
    return this.getStationTransactions$Response(params, context).pipe(
      map((r: StrictHttpResponse<TransactionPagedList>): TransactionPagedList => r.body)
    );
  }

  /** Path part for operation `exportStationTransactionsVnf()` */
  static readonly ExportStationTransactionsVnfPath = '/custom/stations/{uid}/transactions/export';

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportStationTransactionsVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactionsVnf$Response(params: ExportStationTransactionsVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportStationTransactionsVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the transactions assigned to this station.
   *
   * Allows to export the station's transactions as an XLSX File
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportStationTransactionsVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportStationTransactionsVnf(params: ExportStationTransactionsVnf$Params, context?: HttpContext): Observable<Blob> {
    return this.exportStationTransactionsVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getStationChargeOnGoingVnf()` */
  static readonly GetStationChargeOnGoingVnfPath = '/custom/stations/{uid}/charges/ongoing';

  /**
   * Get the ongoing charges for a station.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationChargeOnGoingVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationChargeOnGoingVnf$Response(params: GetStationChargeOnGoingVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargeList>> {
    return getStationChargeOnGoingVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the ongoing charges for a station.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationChargeOnGoingVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationChargeOnGoingVnf(params: GetStationChargeOnGoingVnf$Params, context?: HttpContext): Observable<ChargeList> {
    return this.getStationChargeOnGoingVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<ChargeList>): ChargeList => r.body)
    );
  }

}
